import {JacksonType, JsonSubType} from "@sonner/jackson-service-v2";
import {Papel} from "./papel";
import {PerfilEnum} from "../enums/perfil.enum";

@JacksonType("Construtora")
@JsonSubType({key: 'br.com.sonner.iss.entity.Construtora', type: "Papel"})
export class Construtora extends Papel {

  constructor() {
    super(PerfilEnum.construtora);
  }
}
